import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Col } from 'reactstrap';
import HeadingText from '../../../shared/components/form/HeadingText';
import { DEFAULT_PAGINATION_LENGTH } from '../../../config/app.config';
import PaginationComponent from '../../../shared/components/pagination/Pagination';
import { useGetBroadcasts } from '../../../hooks/broadcasts/useGetBroadcasts';
import { BroadcastArchiveTable } from './Components/BroadcastArchiveTable';
import { CreateBroadcastModal } from './Components/CreateBroadcastModal';
import localStorage from '../../../libs/storageHelper';
import { isSuperAdmin } from '../../../utils/Utils';
import { getAllFacilities } from '../../../redux/actions/staffActions';

function Broadcast() {
  const loggedUser = localStorage.getFromStorage('loggedUser');
  const isSuper = isSuperAdmin(loggedUser?.user);
  const dispatch = useDispatch();
  const facilityAll = useSelector((state) => state.staff?.facilityAll || []);

  useEffect(() => {
    if (isSuper) {
      dispatch(getAllFacilities());
    }
  }, [isSuper, dispatch]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_PAGINATION_LENGTH);

  const page = Math.floor(offset / limit) + 1;

  const { data, refetch, isLoading } = useGetBroadcasts({ page, limit });

  const broadcasts = data?.broadcasts || [];
  const total = data?.total || 0;

  const handlePageLimit = (newLimit) => {
    setLimit(Number(newLimit));
    setOffset(0);
  };

  return (
    <div className="broadcast-news">
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div>
              <HeadingText text="Broadcast" />
              <p className="sub-title">
                {isSuper
                  ? 'Share content on the newsfeeds of Loyal Pet users'
                  : 'Share content on the newsfeeds of Loyal Pet mobile app users'}
              </p>
            </div>
            {isLoading ? (
              <div className="text-center p-4">Loading...</div>
            ) : (
              <>
                <BroadcastArchiveTable
                  broadcasts={broadcasts}
                  isSuperAdmin={isSuper}
                  totalFacilityCount={facilityAll.length}
                  onCreateClick={() => setIsModalOpen(true)}
                />
                <PaginationComponent
                  handlePageLimit={handlePageLimit}
                  nextPage={() => setOffset(offset + limit)}
                  prevPage={() => setOffset(offset - limit)}
                  gotoPage={(p) => setOffset(limit * p)}
                  limit={limit}
                  offset={offset}
                  total={total}
                />
              </>
            )}
          </CardBody>
        </Card>
      </Col>

      <CreateBroadcastModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        isSuperAdmin={isSuper}
        onSuccess={refetch}
      />
    </div>
  );
}

export default Broadcast;
